import React from "react"
import PropTypes from "prop-types"
import { Modal, ModalBody } from "reactstrap"
import CustomButton from "../OnboardingComponents/CustomButton"

export const EXPIRED_INVITE_MESSAGE =
  "This invitation link has expired. Would you like to submit the request again to receive a new invitation?"

/**
 * ExpiredInviteModal — Create Account when the invite link is past expiry.
 */
const ExpiredInviteModal = ({ isOpen, onRequestAgain }) => (
  <Modal
    isOpen={isOpen}
    toggle={() => {}}
    keyboard={false}
    backdrop="static"
    centered
    className="amok-modal amok-modal--invite amok-modal--expired-invite"
    contentClassName="amok-modal__content"
    backdropClassName="amok-modal__backdrop amok-modal-backdrop--blur"
  >
    <ModalBody className="amok-modal__body invites-modal__body">
      <div className="invites-modal expired-invite-modal">
        <div className="invites-modal__main">
          <div className="invites-modal__header">
            <h2 className="invites-modal__title">Invitation Expired</h2>
            <p className="invites-modal__subtitle">{EXPIRED_INVITE_MESSAGE}</p>
          </div>
          <div className="expired-invite-modal__actions">
            <CustomButton
              type="button"
              variant="primary"
              size="md"
              fullWidth
              onClick={onRequestAgain}
            >
              Request Invite Again
            </CustomButton>
          </div>
        </div>
      </div>
    </ModalBody>
  </Modal>
)

ExpiredInviteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestAgain: PropTypes.func.isRequired,
}

export default ExpiredInviteModal
